import PropTypes from 'prop-types';
import React, { PureComponent, useContext } from 'react';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import { withCookies } from 'react-cookie';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { accountInformationValidationSchema } from '@client/shared/utils/validation/validationSchemas/accountInformationSchema';
import {
  selectAccessToken,
  selectUserInfo,
} from '@client/redux/user/userReducer';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { capitalizeFirstLetter } from '@client/shared/utils/utils/utils';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import FormWrapper from '@client/components/formComponents/formWrapper/FormWrapper';
import { putAndHandleUser } from '@client/redux/user/userActions';
import { handleLogout } from '@client/redux/user';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { NotificationContext } from '@client/components/notificationProvider/NotificationProvider';
import {
  SUCCESS,
  ERROR,
  INFORMATION_SAVED,
  AN_ERROR_OCCURRED,
  MY_INFORMATION,
} from '@client/definitions/constants';
import styles from './accountInformationRoute.scss';
import FormAccountInformation from './formAccountInformation/FormAccountInformation';

function FormContainer({ userInfo, dispatch, cookies }) {
  const context = useContext(NotificationContext);
  const auth = useAuth0();

  const renderAccountInformationForm = (formProps) => {
    return <FormAccountInformation formProps={formProps} userInfo={userInfo} />;
  };

  const handleAccountInformationSubmit = (values) => {
    const initialEmailVal = getIn(userInfo, 'email');
    const payload = Object.assign({}, values);
    const isEmailUpdated = initialEmailVal !== payload.email;

    !isEmailUpdated && delete payload.email;

    dispatch(putAndHandleUser(payload, getIn(userInfo, 'sub')))
      .then(() => {
        context.displayNotification(SUCCESS, INFORMATION_SAVED);
        if (isEmailUpdated) {
          dispatch(handleLogout(cookies));
          auth.logout();
        }
      })
      .catch((error) => {
        if (error) {
          const errorText = error.detail ? error.detail : AN_ERROR_OCCURRED;
          context.displayNotification(ERROR, errorText);
        }
      });
  };

  return (
    <FormWrapper
      initialValues={{
        firstName: getIn(userInfo, 'given_name'),
        lastName: getIn(userInfo, 'family_name'),
        email: getIn(userInfo, 'email'),
      }}
      onSubmit={handleAccountInformationSubmit}
      component={renderAccountInformationForm}
      validateOnBlur={true}
      validateOnChange={false}
      transformationSchema={{
        firstName: capitalizeFirstLetter,
        lastName: capitalizeFirstLetter,
      }}
      validationSchema={accountInformationValidationSchema()}
    />
  );
}

class AccountInformationRoute extends PureComponent {
  static contextType = NotificationContext;

  render() {
    const { accessToken, userInfo, dispatch, cookies } = this.props;

    return (
      <div className={styles.accountInformationRoute}>
        <h3
          className={`${styleHelper.titleMdPrimary} ${styleHelper._title} ${styles.title}`}
        >
          {MY_INFORMATION}
        </h3>
        <FormContainer
          userInfo={userInfo}
          accessToken={accessToken}
          cookies={cookies}
          dispatch={dispatch}
        />
      </div>
    );
  }
}

FormContainer.propTypes = {
  dispatch: PropTypes.func,
  accessToken: PropTypes.string,
  userInfo: ImmutablePropTypes.map,
  cookies: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    userInfo: selectUserInfo(state),
    accessToken: selectAccessToken(state),
  };
}

export default withRouter(
  withCookies(connect(mapStateToProps)(AccountInformationRoute))
);
